import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  LOGIN_FAILED,
  API_ERROR,
  SOCIAL_LOGIN,
  LOGIN_USER_RESET,
  RESET_LOGIN_RESPONSE_MSG,
  FETCH_CONST_DETAILS,
  SET_CONST_DETAILS,
  LOGOUT_USER_FAILED,
  SESSION_TIMEOUT,
} from "./actionTypes"

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const loginFailed = (payload) => {
  return {
    type: LOGIN_FAILED,
    payload: payload,
  }
}

export const logoutUser = payload => {
  return {
    type: LOGOUT_USER,
    payload: payload,
  }
}

export const logoutUserSuccess = (payload) => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: payload,
  }
}
export const logoutUserFailed = (payload) => {
  return {
    type: LOGOUT_USER_FAILED,
    payload: payload,
  }
}
export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const socialLogin = (data, history, type) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { data, history, type },
  }
}

export const LoginUserReset = user => {
  return {
    type: LOGIN_USER_RESET,
  }
}

export const resetLoginResponseMsg = (payload) => {
  return {
    type: RESET_LOGIN_RESPONSE_MSG,
    payload: payload,
  }
}

export const FetchConstDetails = (payload) => {
  return {
    type: FETCH_CONST_DETAILS,
    payload: payload,
  }
}

export const SetConstDetails = (payload) => {
  return {
    type: SET_CONST_DETAILS,
    payload: payload,
  }
}
export const setSessionTimeOut = (payload) => {
  return {
    type: SESSION_TIMEOUT,
    payload: payload,
  }
}

